import { COLORS, Text } from "@asayinc/component-library";
import { AccountBalanceOutlined, Email } from "@mui/icons-material";
import { Box, IconButton, SxProps } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface IEventPageHeader {
  backLink: string;
  issuerName: string;
  issuerId: string;
  type: string;
  subHeader?: string;
  sx?: SxProps;
}

export function EventPageHeader({
  backLink,
  issuerName,
  issuerId,
  type,
  subHeader,
  sx,
}: IEventPageHeader) {
  const navigate = useNavigate();

  const handleIssuerClick = () => {
    navigate(`/issuers/${issuerId}/proxy-events`, {
      state: { backLink },
    });
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", ...sx }}>
      <Box
        sx={{
          pt: "14px",
          pb: "8px",
          px: "14px",
          backgroundColor: "#3D3D3D",
          borderRadius: 2,
          mr: 4,
        }}
      >
        <Email sx={{ borderRadius: 2, color: "white" }} />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Text
            sx={{ mr: 2 }}
            variant="subtitle1"
            data-testid="page-header-type"
          >
            {type}
          </Text>
          for
          <Text
            sx={{ mx: 2, cursor: issuerId ? "pointer" : "auto" }}
            variant="subtitle1"
            data-testid="page-header-issuer"
            onClick={handleIssuerClick}
          >
            {issuerName}
          </Text>
          <IconButton onClick={handleIssuerClick} size="small">
            <AccountBalanceOutlined style={{ color: "black" }} />
          </IconButton>
        </Box>
        <Text
          color={COLORS.P_MED_EMPHASIS}
          data-testid="page-header-start-date"
          sx={{ mr: 2, color: COLORS.P_MED_EMPHASIS, mt: 1 }}
          variant="body2"
        >
          {subHeader}
        </Text>
      </Box>
    </Box>
  );
}
